import { createContext } from "react";

export const BatchContentsContext = createContext();
